module.exports = __webpack_public_path__ + "img/热恋推荐标签.29d5f642.png";